export enum EServiceType {
  BRCGS = 'BRCGS',
  CLC = 'CLC',
  CSM = 'CSM',
  CTPAT = 'C-TPAT',
  DN = 'DN',
  DR = 'DR',
  DUPRO = 'DUPRO',
  EA = 'EA',
  ENVA = 'ENVA',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'G-MARK' = 'G-MARK',
  GGAP = 'GGAP',
  GHP = 'GHP',
  GMARK = 'GMARK',
  GMP = 'GMP',
  IFS = 'IFS',
  ILI = 'ILI',
  IPC = 'IPC',
  LT = 'LT',
  MA = 'MA',
  PEO = 'PEO',
  PM = 'PM',
  PSI = 'PSI',
  SABER = 'SABER',
  SAQ = 'SAQ',
  SASO = 'SASO',
  SASOREGISTRATION = 'saso-registration',
  SC = 'SC',
  SP = 'SP',
  SQF = 'SQF',
  SR = 'SR',
  STRA = 'STRA',
  STS = 'STS',
  TSM = 'TSM',
  WCP = 'WCP',
  WQS = 'WQS',
}
